

// import React, { useRef, useState } from "react";
// import { Modal, Button } from "react-bootstrap";
// import ReactCrop from "react-image-crop";
// import "react-image-crop/dist/ReactCrop.css";
// import { FaCheck, FaCrop, FaSearchMinus, FaSearchPlus } from "react-icons/fa";

// const ImageCropperModal = ({
//   show,
//   imageUrl,
//   type, // 'logo' | 'mainImage'
//   onClose,
//   onCropped, // returns cropped file
// }) => {
//   const imageRef = useRef(null);
//   const canvasRef = useRef(null);

//   const [crop, setCrop] = useState({
//     unit: "px",
//     width: type === "logo" ? 50 : 1920,
//     height: type === "logo" ? 50 : 1080,
//     x: 0,
//     y: 0
//   });

//   const [completedCrop, setCompletedCrop] = useState(null);
//   const [scale, setScale] = useState(1);
//   const [rotate, setRotate] = useState(0);

//   const defaultCrops = {
//     logo: { unit: "px", width: 50, height: 50, x: 0, y: 0 },
//     mainImage: { unit: "px", width: 1920, height: 1080, x: 0, y: 0 }
//   };

//   // Extract cropped image as Blob
//   const getCroppedImg = (image, crop, fileName) => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     if (!image || !crop) return;

//     const scaleX = image.naturalWidth / image.width;
//     const scaleY = image.naturalHeight / image.height;
//     const pixelRatio = window.devicePixelRatio;

//     canvas.width = crop.width * pixelRatio;
//     canvas.height = crop.height * pixelRatio;

//     ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
//     ctx.imageSmoothingQuality = "high";

//     ctx.drawImage(
//       image,
//       crop.x * scaleX,
//       crop.y * scaleY,
//       crop.width * scaleX,
//       crop.height * scaleY,
//       0,
//       0,
//       crop.width,
//       crop.height
//     );

//     return new Promise((resolve) => {
//       canvas.toBlob(
//         (blob) => {
//           if (!blob) return;
//           blob.name = fileName;
//           resolve(blob);
//         },
//         "image/jpeg",
//         1
//       );
//     });
//   };

//   const handleApplyCrop = async () => {
//     if (!imageRef.current || !completedCrop) return;

//     const croppedBlob = await getCroppedImg(
//       imageRef.current,
//       completedCrop,
//       `cropped-${type}.jpg`
//     );

//     if (!croppedBlob) return;

//     const croppedFile = new File(
//       [croppedBlob],
//       `cropped-${type}.jpg`,
//       { type: "image/jpeg" }
//     );

//     onCropped(croppedFile); // send file to parent
//     onClose();
//   };

//   return (
//     <>
//       <Modal show={show} onHide={onClose} size="lg" centered>
//         <Modal.Header closeButton>
//           <Modal.Title>
//             <FaCrop className="me-2" /> Crop {type === "logo" ? "Logo" : "Main Image"}
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           {imageUrl && (
//             <div className="text-center">
//               <ReactCrop
//                 crop={crop}
//                 onChange={(c) => setCrop(c)}
//                 onComplete={(c) => setCompletedCrop(c)}
//                 aspect={type === "logo" ? 1 : 16 / 9}
//                 minWidth={type === "logo" ? 50 : 1920}
//                 minHeight={type === "logo" ? 50 : 1080}
//               >
//                 <img
//                   ref={imageRef}
//                   src={imageUrl}
//                   alt="Crop"
//                   style={{
//                     transform: `scale(${scale}) rotate(${rotate}deg)`,
//                     maxHeight: "60vh",
//                     maxWidth: "100%"
//                   }}
//                   onLoad={() => {
//                     if (!imageRef.current) return;
//                     const { width, height } = imageRef.current;

//                     if (type === "logo") {
//                       const size = Math.min(width, height, 50);
//                       setCrop({
//                         ...defaultCrops.logo,
//                         width: size,
//                         height: size,
//                         x: (width - size) / 2,
//                         y: (height - size) / 2
//                       });
//                     } else {
//                       setCrop(defaultCrops.mainImage);
//                     }
//                   }}
//                 />
//               </ReactCrop>
//             </div>
//           )}

//           {/* Controls */}
//           <div className="d-flex justify-content-between align-items-center mt-3">
//             <div className="d-flex gap-2">
//               <Button variant="outline-secondary" size="sm" onClick={() => setScale((s) => Math.max(0.1, s - 0.1))}>
//                 <FaSearchMinus />
//               </Button>
//               <Button variant="outline-secondary" size="sm" onClick={() => setScale((s) => Math.min(3, s + 0.1))}>
//                 <FaSearchPlus />
//               </Button>
//               <span className="mx-2">Zoom: {(scale * 100).toFixed(0)}%</span>
//             </div>

//             {/* <div className="d-flex gap-2">
//               <Button variant="outline-secondary" size="sm" onClick={() => setRotate((r) => (r - 90) % 360)}>
//                 <FaRotateLeft />
//               </Button>
//               <Button variant="outline-secondary" size="sm" onClick={() => setRotate((r) => (r + 90) % 360)}>
//                 <FaRotateLeft style={{ transform: "scaleX(-1)" }} />
//               </Button>
//               <span className="mx-2">Rotate: {rotate}°</span>
//             </div> */}
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button variant="secondary" onClick={onClose}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleApplyCrop} disabled={!completedCrop}>
//             <FaCheck className="me-2" /> Apply Crop
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <canvas ref={canvasRef} style={{ display: "none" }} />
//     </>
//   );
// };

// export default ImageCropperModal;



// import React, { useRef, useState } from "react";
// import { Modal, Button } from "react-bootstrap";
// import ReactCrop from "react-image-crop";
// import "react-image-crop/dist/ReactCrop.css";
// import { FaCheck, FaCrop, FaSearchMinus, FaSearchPlus } from "react-icons/fa";

// const ImageCropperModal = ({
//   show,
//   imageUrl,
//   type, // 'logo' | 'mainImage'
//   onClose,
//   onCropped,
// }) => {
//   const imageRef = useRef(null);
//   const canvasRef = useRef(null);

//   const [crop, setCrop] = useState({
//     unit: "px",
//     width: type === "logo" ? 50 : 300,
//     height: type === "logo" ? 50 : 169,
//     x: 0,
//     y: 0
//   });

//   const [completedCrop, setCompletedCrop] = useState(null);
//   const [scale, setScale] = useState(1);
//   const [rotate, setRotate] = useState(0);

//   const defaultCrops = {
//     logo: { unit: "px", width: 50, height: 50, x: 0, y: 0 },
//     mainImage: { unit: "px", width: 300, height: 169, x: 0, y: 0 }
//   };

//   // Extract cropped image as Blob
//   const getCroppedImg = (image, crop, fileName) => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     if (!image || !crop) return;

//     const scaleX = image.naturalWidth / image.width;
//     const scaleY = image.naturalHeight / image.height;
//     const pixelRatio = window.devicePixelRatio;

//     canvas.width = crop.width * pixelRatio;
//     canvas.height = crop.height * pixelRatio;

//     ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
//     ctx.imageSmoothingQuality = "high";

//     ctx.drawImage(
//       image,
//       crop.x * scaleX,
//       crop.y * scaleY,
//       crop.width * scaleX,
//       crop.height * scaleY,
//       0,
//       0,
//       crop.width,
//       crop.height
//     );

//     return new Promise((resolve) => {
//       canvas.toBlob(
//         (blob) => {
//           if (!blob) return;
//           blob.name = fileName;
//           resolve(blob);
//         },
//         "image/jpeg",
//         1
//       );
//     });
//   };

//   const handleApplyCrop = async () => {
//     if (!imageRef.current || !completedCrop) return;

//     const croppedBlob = await getCroppedImg(
//       imageRef.current,
//       completedCrop,
//       `cropped-${type}.jpg`
//     );

//     if (!croppedBlob) return;

//     const croppedFile = new File(
//       [croppedBlob],
//       `cropped-${type}.jpg`,
//       { type: "image/jpeg" }
//     );

//     onCropped(croppedFile);
//     onClose();
//   };

//   return (
//     <>
//       <Modal show={show} onHide={onClose} size="xl" centered backdrop="static">
//         <Modal.Header closeButton>
//           <Modal.Title>
//             <FaCrop className="me-2" /> Crop {type === "logo" ? "Logo" : "Main Image"}
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           {imageUrl && (
//             <div className="text-center">
//               <ReactCrop
//                 crop={crop}
//                 locked={true}
//                 onChange={(c) => setCrop(c)}
//                 onComplete={(c) => setCompletedCrop(c)}
//                 aspect={type === "logo" ? 1 : 16 / 9}
//                 minWidth={type === "logo" ? 50 : 300}
//                 minHeight={type === "logo" ? 50 : 169}
//               >
//                 <img
//                   ref={imageRef}
//                   src={imageUrl}
//                   alt="Crop"
//                   style={{
//                     transform: `scale(${scale}) rotate(${rotate}deg)`,
//                     maxHeight: "60vh",
//                     maxWidth: "100%"
//                   }}
//                   onLoad={() => {
//                     if (!imageRef.current) return;
//                     const { width, height } = imageRef.current;

//                     if (type === "logo") {
//                       const size = Math.min(width, height, 50);
//                       setCrop({
//                         unit: "px",
//                         width: size,
//                         height: size,
//                         x: (width - size) / 2,
//                         y: (height - size) / 2
//                       });
//                     } else {
//                       // Centered 16:9 crop
//                       const cropWidth = Math.min(width * 0.8, 300);
//                       const cropHeight = cropWidth * (9 / 16);

//                       setCrop({
//                         unit: "px",
//                         width: cropWidth,
//                         height: cropHeight,
//                         x: (width - cropWidth) / 2,
//                         y: (height - cropHeight) / 2
//                       });
//                     }
//                   }}
//                 />
//               </ReactCrop>
//             </div>
//           )}

//           {/* Controls */}
//           <div className="d-flex justify-content-between align-items-center mt-3">
//             <div className="d-flex gap-2">
//               <Button
//                 variant="outline-secondary"
//                 size="sm"
//                 onClick={() => setScale((s) => Math.max(0.1, s - 0.1))}
//               >
//                 <FaSearchMinus />
//               </Button>
//               <Button
//                 variant="outline-secondary"
//                 size="sm"
//                 onClick={() => setScale((s) => Math.min(3, s + 0.1))}
//               >
//                 <FaSearchPlus />
//               </Button>
//               <span className="mx-2">Zoom: {(scale * 100).toFixed(0)}%</span>
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button variant="secondary" onClick={onClose}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleApplyCrop} disabled={!completedCrop}>
//             <FaCheck className="me-2" /> Apply Crop
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <canvas ref={canvasRef} style={{ display: "none" }} />
//     </>
//   );
// };

// export default ImageCropperModal;


// import React, { useRef, useState, useEffect } from "react";
// import { Modal, Button } from "react-bootstrap";
// import ReactCrop from "react-image-crop";
// import "react-image-crop/dist/ReactCrop.css";
// import { FaCheck, FaCrop, FaSearchMinus, FaSearchPlus } from "react-icons/fa";

// const ImageCropperModal = ({
//   show,
//   imageUrl,
//   type, // 'logo' | 'mainImage'
//   onClose,
//   onCropped,
// }) => {
//   const imageRef = useRef(null);
//   const canvasRef = useRef(null);

//   console.log(window.imageConfig)

//   let LOGO_SIZE = window.imageConfig?.STORE_LOGO_SIZE || { width: 50, height: 50 };
//   let MAIN_IMAGE_SIZE = window.imageConfig?.STORE_MAIN_IMAGE_SIZE || { width: 300, height: 169 };

//   const [crop, setCrop] = useState({
//     unit: "px",
//     width: type === "logo" ? LOGO_SIZE.width : MAIN_IMAGE_SIZE.width,
//     height: type === "logo" ? LOGO_SIZE.height : MAIN_IMAGE_SIZE.height,
//     x: 0,
//     y: 0
//   });


//   const [completedCrop, setCompletedCrop] = useState(null);
//   const [scale, setScale] = useState(1);
//   const [rotate, setRotate] = useState(0);
//   const [imageLoaded, setImageLoaded] = useState(false);

//   // Extract cropped image as Blob with maximum size constraints
//   const getCroppedImg = (image, crop, fileName) => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     if (!image || !crop) return;

//     const scaleX = image.naturalWidth / image.width;
//     const scaleY = image.naturalHeight / image.height;
//     const pixelRatio = window.devicePixelRatio;

//     // For main images, limit the maximum output size to 1920x1080
//     let outputWidth = crop.width;
//     let outputHeight = crop.height;

//     if (type === "mainImage") {
//       const maxWidth = MAIN_IMAGE_SIZE.width || 1920;
//       const maxHeight = MAIN_IMAGE_SIZE.height || 1080;

//       // Calculate scaling to fit within max dimensions while maintaining aspect ratio
//       const scaleFactor = Math.min(
//         maxWidth / crop.width,
//         maxHeight / crop.height,
//         1 // Don't scale up, only down
//       );

//       outputWidth = crop.width * scaleFactor;
//       outputHeight = crop.height * scaleFactor;
//     }

//     canvas.width = outputWidth * pixelRatio;
//     canvas.height = outputHeight * pixelRatio;

//     ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
//     ctx.imageSmoothingQuality = "high";

//     ctx.drawImage(
//       image,
//       crop.x * scaleX,
//       crop.y * scaleY,
//       crop.width * scaleX,
//       crop.height * scaleY,
//       0,
//       0,
//       outputWidth,
//       outputHeight
//     );

//     return new Promise((resolve) => {
//       canvas.toBlob(
//         (blob) => {
//           if (!blob) return;
//           blob.name = fileName;
//           resolve(blob);
//         },
//         "image/jpeg",
//         1
//       );
//     });
//   };

//   const handleApplyCrop = async () => {
//     if (!imageRef.current || !completedCrop) return;

//     const croppedBlob = await getCroppedImg(
//       imageRef.current,
//       completedCrop,
//       `cropped-${type}.jpg`
//     );

//     if (!croppedBlob) return;

//     const croppedFile = new File(
//       [croppedBlob],
//       `cropped-${type}.jpg`,
//       { type: "image/jpeg" }
//     );

//     onCropped(croppedFile);
//     onClose();
//   };

//   // Set appropriate crop dimensions based on image size and type
//   const setOptimalCrop = () => {
//     if (!imageRef.current) return;

//     const { width, height } = imageRef.current;

//     if (type === "logo") {
//       const size = Math.min(width, height, 50);
//       const newCrop = {
//         unit: "px",
//         width: size,
//         height: size,
//         x: (width - size) / 2,
//         y: (height - size) / 2
//       };
//       setCrop(newCrop);
//       setCompletedCrop(newCrop); // Auto-set completed crop for logo
//     } else {
//       // For main image, set crop to maximum possible 16:9 area
//       // but don't exceed the image dimensions
//       let cropWidth, cropHeight;

//       // Calculate maximum 16:9 crop that fits within the image
//       const aspectRatio = 16 / 9;

//       if (width / height > aspectRatio) {
//         // Image is wider than 16:9
//         cropHeight = Math.min(height, 1080);
//         cropWidth = cropHeight * aspectRatio;
//       } else {
//         // Image is taller than 16:9
//         cropWidth = Math.min(width, 1920);
//         cropHeight = cropWidth / aspectRatio;
//       }

//       // Ensure we don't exceed image dimensions
//       cropWidth = Math.min(cropWidth, width);
//       cropHeight = Math.min(cropHeight, height);

//       const newCrop = {
//         unit: "px",
//         width: cropWidth,
//         height: cropHeight,
//         x: (width - cropWidth) / 2,
//         y: (height - cropHeight) / 2
//       };

//       setCrop(newCrop);
//       setCompletedCrop(newCrop); // Auto-set completed crop for main image
//     }

//     setImageLoaded(true);
//   };

//   // Auto-enable apply button when image loads with perfect dimensions
//   useEffect(() => {
//     if (imageLoaded && completedCrop) {
//       // The button will now be enabled because completedCrop is set
//     }
//   }, [imageLoaded, completedCrop]);

//   return (
//     <>
//       <Modal show={show} onHide={onClose} size="xl" centered backdrop="static">
//         <Modal.Header closeButton>
//           <Modal.Title className="d-flex justify-content-between align-items-center w-100">
//             <div>
//               <FaCrop className="me-2" /> Crop
//               <span className="fw-bold px-1">
//                 {type === "logo" ? "Logo" : "Main Image"}
//               </span>
//               {type === "mainImage" && <small className="text-muted ms-2">(Max: 1920×1080)</small>}
//             </div>

//             {/* Controls */}
//             <div className="d-flex justify-content-between align-items-center px-4">
//               <div className="d-flex gap-2">
//                 <span className="mx-2">{(scale * 100).toFixed(0)}%</span>
//                 <Button
//                   variant="outline-secondary"
//                   size="sm"
//                   onClick={() => setScale((s) => Math.max(0.1, s - 0.1))}
//                 >
//                   <FaSearchMinus />
//                 </Button>
//                 <Button
//                   variant="outline-secondary"
//                   size="sm"
//                   onClick={() => setScale((s) => Math.min(3, s + 0.1))}
//                 >
//                   <FaSearchPlus />
//                 </Button>
//               </div>
//             </div>
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           {imageUrl && (
//             <div className="text-center">
//               <ReactCrop
//                 crop={crop}
//                 locked
//                 onChange={(c) => setCrop(c)}
//                 onComplete={(c) => setCompletedCrop(c)}
//                 aspect={type === "logo" ? 1 : 16 / 9}
//                 minWidth={type === "logo" ? LOGO_SIZE.width : 100}
//                 minHeight={type === "logo" ? LOGO_SIZE.height : 56}
//                 maxWidth={type === "mainImage" ? 1920 : undefined}
//                 maxHeight={type === "mainImage" ? 1080 : undefined}
//               >
//                 <img
//                   ref={imageRef}
//                   src={imageUrl}
//                   alt="Crop"
//                   style={{
//                     transform: `scale(${scale}) rotate(${rotate}deg)`,
//                     maxHeight: "60vh",
//                     maxWidth: "100%"
//                   }}
//                   onLoad={setOptimalCrop}
//                 />
//               </ReactCrop>
//             </div>
//           )}


//         </Modal.Body>

//         <Modal.Footer>
//           <Button variant="secondary" onClick={onClose}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleApplyCrop} disabled={!completedCrop}>
//             <FaCheck className="me-2" /> Apply
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <canvas ref={canvasRef} style={{ display: "none" }} />
//     </>
//   );
// };

// export default ImageCropperModal;


// import React, { useRef, useState, useEffect } from "react";
// import { Modal, Button } from "react-bootstrap";
// import ReactCrop from "react-image-crop";
// import "react-image-crop/dist/ReactCrop.css";
// import { FaCheck, FaCrop, FaSearchMinus, FaSearchPlus } from "react-icons/fa";

// const ImageCropperModal = ({
//   show,
//   imageUrl,
//   type, // 'logo' | 'mainImage'
//   onClose,
//   onCropped,
// }) => {
//   const imageRef = useRef(null);
//   const canvasRef = useRef(null);

//   const LOGO_SIZE = window.imageConfig?.STORE_LOGO_SIZE || { width: 50, height: 50 };
//   const MAIN_IMAGE_SIZE = window.imageConfig?.STORE_MAIN_IMAGE_SIZE || { width: 1920, height: 1080 };

//   const targetSize = type === "logo" ? LOGO_SIZE : MAIN_IMAGE_SIZE;
//   const aspectRatio = type === "logo" ? LOGO_SIZE.width / LOGO_SIZE.height : MAIN_IMAGE_SIZE.width / MAIN_IMAGE_SIZE.height;

//   const [crop, setCrop] = useState({
//     unit: "px",
//     width: targetSize.width,
//     height: targetSize.height,
//     x: 0,
//     y: 0
//   });

//   const [completedCrop, setCompletedCrop] = useState(null);
//   const [scale, setScale] = useState(1);
//   const [rotate, setRotate] = useState(0);
//   const [imageLoaded, setImageLoaded] = useState(false);

//   // Extract cropped image as Blob with exact size output
//   const getCroppedImg = (image, crop, fileName) => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     if (!image || !crop) return;

//     const scaleX = image.naturalWidth / image.width;
//     const scaleY = image.naturalHeight / image.height;
//     const pixelRatio = window.devicePixelRatio;

//     // Use exact target size from config
//     const outputWidth = targetSize.width;
//     const outputHeight = targetSize.height;

//     canvas.width = outputWidth * pixelRatio;
//     canvas.height = outputHeight * pixelRatio;

//     ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
//     ctx.imageSmoothingQuality = "high";

//     ctx.drawImage(
//       image,
//       crop.x * scaleX,
//       crop.y * scaleY,
//       crop.width * scaleX,
//       crop.height * scaleY,
//       0,
//       0,
//       outputWidth,
//       outputHeight
//     );

//     return new Promise((resolve) => {
//       canvas.toBlob(
//         (blob) => {
//           if (!blob) return;
//           blob.name = fileName;
//           resolve(blob);
//         },
//         "image/jpeg",
//         1
//       );
//     });
//   };

//   const handleApplyCrop = async () => {
//     if (!imageRef.current || !completedCrop) return;

//     const croppedBlob = await getCroppedImg(
//       imageRef.current,
//       completedCrop,
//       `cropped-${type}.jpg`
//     );

//     if (!croppedBlob) return;

//     const croppedFile = new File(
//       [croppedBlob],
//       `cropped-${type}.jpg`,
//       { type: "image/jpeg" }
//     );

//     onCropped(croppedFile);
//     onClose();
//   };

//   // Set appropriate crop dimensions based on image size and type
//   const setOptimalCrop = () => {
//     if (!imageRef.current) return;

//     const { width, height } = imageRef.current;

//     if (type === "logo") {
//       // For logo, use centered crop with config aspect ratio
//       let cropWidth, cropHeight;

//       if (width / height > aspectRatio) {
//         // Image is wider than target aspect ratio
//         cropHeight = Math.min(height, targetSize.height);
//         cropWidth = cropHeight * aspectRatio;
//       } else {
//         // Image is taller than target aspect ratio
//         cropWidth = Math.min(width, targetSize.width);
//         cropHeight = cropWidth / aspectRatio;
//       }

//       // Ensure we don't exceed image dimensions
//       cropWidth = Math.min(cropWidth, width);
//       cropHeight = Math.min(cropHeight, height);

//       const newCrop = {
//         unit: "px",
//         width: cropWidth,
//         height: cropHeight,
//         x: (width - cropWidth) / 2,
//         y: (height - cropHeight) / 2
//       };
//       setCrop(newCrop);
//       setCompletedCrop(newCrop);
//     } else {
//       // For main image, set crop to maximum possible area with config aspect ratio
//       let cropWidth, cropHeight;

//       if (width / height > aspectRatio) {
//         // Image is wider than target aspect ratio
//         cropHeight = Math.min(height, targetSize.height);
//         cropWidth = cropHeight * aspectRatio;
//       } else {
//         // Image is taller than target aspect ratio
//         cropWidth = Math.min(width, targetSize.width);
//         cropHeight = cropWidth / aspectRatio;
//       }

//       // Ensure we don't exceed image dimensions
//       cropWidth = Math.min(cropWidth, width);
//       cropHeight = Math.min(cropHeight, height);

//       const newCrop = {
//         unit: "px",
//         width: cropWidth,
//         height: cropHeight,
//         x: (width - cropWidth) / 2,
//         y: (height - cropHeight) / 2
//       };

//       setCrop(newCrop);
//       setCompletedCrop(newCrop);
//     }

//     setImageLoaded(true);
//   };

//   // Reset when modal opens or config changes
//   useEffect(() => {
//     if (show) {
//       setScale(1);
//       setRotate(0);
//       setImageLoaded(false);
//       // Reset crop to current config defaults
//       setCrop({
//         unit: "px",
//         width: targetSize.width,
//         height: targetSize.height,
//         x: 0,
//         y: 0
//       });
//       setCompletedCrop(null);
//     }
//   }, [show, imageUrl, type, targetSize.width, targetSize.height]);

//   return (
//     <>
//       <Modal show={show} onHide={onClose} size="xl" centered backdrop="static">
//         <Modal.Header closeButton>
//           <Modal.Title className="d-flex justify-content-between align-items-center w-100">
//             <div>
//               <FaCrop className="me-2" /> Crop
//               <span className="fw-bold px-1">
//                 {type === "logo" ? "Logo" : "Main Image"}
//               </span>
//             </div>

//             {/* Controls */}
//             <div className="d-flex justify-content-between align-items-center px-4">
//               <div className="d-flex gap-2 align-items-center">
//                 <span className="mx-2">{(scale * 100).toFixed(0)}%</span>
//                 <Button
//                   variant="outline-secondary"
//                   size="sm"
//                   onClick={() => setScale((s) => Math.max(0.1, s - 0.1))}
//                 >
//                   <FaSearchMinus />
//                 </Button>
//                 <Button
//                   variant="outline-secondary"
//                   size="sm"
//                   onClick={() => setScale((s) => Math.min(3, s + 0.1))}
//                 >
//                   <FaSearchPlus />
//                 </Button>
//               </div>
//             </div>
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           {imageUrl && (
//             <div className="text-center">
//               <ReactCrop
//                 crop={crop}
//                 onChange={(c) => setCrop(c)}
//                 onComplete={(c) => setCompletedCrop(c)}
//                 aspect={aspectRatio}
//                 minWidth={type === "logo" ? LOGO_SIZE.width : 100}
//                 minHeight={type === "logo" ? LOGO_SIZE.height : 56}
//                 maxWidth={type === "mainImage" ? MAIN_IMAGE_SIZE.width : undefined}
//                 maxHeight={type === "mainImage" ? MAIN_IMAGE_SIZE.height : undefined}
//                 locked
//               >
//                 <img
//                   ref={imageRef}
//                   src={imageUrl}
//                   alt="Crop"
//                   style={{
//                     transform: `scale(${scale}) rotate(${rotate}deg)`,
//                     maxHeight: "60vh",
//                     maxWidth: "100%"
//                   }}
//                   onLoad={setOptimalCrop}
//                 />
//               </ReactCrop>
//             </div>
//           )}


//         </Modal.Body>

//         <Modal.Footer>
//           <Button variant="secondary" onClick={onClose}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleApplyCrop} disabled={!completedCrop}>
//             <FaCheck className="me-2" /> Apply
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <canvas ref={canvasRef} style={{ display: "none" }} />
//     </>
//   );
// };

// export default ImageCropperModal;



import React, { useState, useRef, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import Cropper from "react-easy-crop";
import { FaCheck, FaSearchMinus, FaSearchPlus, FaCrop } from "react-icons/fa";

const ImageCropperModal = ({
  show,
  imageUrl,
  type,
  onClose,
  onCropped
}) => {
  const cropperRef = useRef(null);

  const LOGO_SIZE = window.imageConfig?.STORE_LOGO_SIZE || { width: 50, height: 50 };
  const MAIN_IMAGE_SIZE = window.imageConfig?.STORE_MAIN_IMAGE_SIZE || { width: 1920, height: 1080 };

  const targetSize = type === "logo" ? LOGO_SIZE : MAIN_IMAGE_SIZE;
  const aspectRatio = targetSize.width / targetSize.height;


  // easy crop states
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // When crop is done, store crop area in pixels
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // Convert cropped area to file (output size is EXACT based on config)
  const getCroppedImageBlob = async () => {
    const image = await createImage(imageUrl);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = targetSize.width;
    canvas.height = targetSize.height;

    ctx.drawImage(
      image,
      croppedAreaPixels.x,
      croppedAreaPixels.y,
      croppedAreaPixels.width,
      croppedAreaPixels.height,
      0,
      0,
      targetSize.width,
      targetSize.height
    );

    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => resolve(blob),
        "image/jpeg",
        1
      );
    });
  };

  const handleApplyCrop = async () => {
    if (!croppedAreaPixels) return;

    const blob = await getCroppedImageBlob();
    const file = new File([blob], `cropped-${type}.jpg`, { type: "image/jpeg" });

    onCropped(file);
    onClose();
  };

  // Utility: Create image from URL
  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.addEventListener("load", () => resolve(img));
      img.addEventListener("error", (err) => reject(err));
      img.src = url;
    });


  return (
    <>
      <Modal show={show} onHide={onClose} size="xl" backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title className="d-flex justify-content-between align-items-center w-100">
            <span>
              <FaCrop className="me-2" />
              Crop <strong>{type === "logo" ? "Logo" : "Main Image"}</strong>
            </span>

            <div className="d-flex align-items-center gap-3 px-4">
              <span>{(zoom * 100).toFixed(0)}%</span>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => setZoom((z) => Math.max(0.5, z - 0.1))}
              >
                <FaSearchMinus />
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => setZoom((z) => Math.min(3, z + 0.1))}
              >
                <FaSearchPlus />
              </Button>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {imageUrl && (
            <div style={{ position: "relative", width: "100%", height: "70vh" }}>
              <Cropper
                image={imageUrl}
                crop={crop}
                zoom={zoom}
                aspect={aspectRatio}
                // cropSize={{
                //   width:  targetSize.width,
                //   height: targetSize.height
                // }}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
                cropShape="rect"
                showGrid={false}
                objectFit="contain"
              />
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>

          <Button
            variant="primary"
            disabled={!croppedAreaPixels}
            onClick={handleApplyCrop}
          >
            <FaCheck className="me-2" /> Apply
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ImageCropperModal;
